import { Metric, MetricType } from 'web-vitals';

const reportWebVitals = (onReport?: (metric: MetricType) => void) => {
  if (onReport) {
    import('web-vitals').then(({ onCLS, onFCP, onFID, onINP, onLCP, onTTFB }) => {
      onCLS(onReport);
      onFCP(onReport);
      onFID(onReport);
      onINP(onReport);
      onLCP(onReport);
      onTTFB(onReport);
    });
  }
};

export const sendToAnalytics = (metric: Metric) => {
  // Note: JSON.stringify will likely include more data than you need.
  const body = JSON.stringify(metric);

  // Replace console.log and use the commented code below,
  // Please replace '/analytics with path to url where you would collect data
  console.log(body);

  //(navigator.sendBeacon && navigator.sendBeacon('/analytics', body)) ||
  //  fetch('/analytics', { body, method: 'POST', keepalive: true });
};

export default reportWebVitals;
